import React from 'react';
import './About.css';

const About = () => {
  const teamMembers = [
    {
      name: 'Gaurav N Kumar',
      position: 'CEO',
      image: '/Picture4.png'
    },
    {
      name: 'Vishal R Shetty',
      position: 'CTO',
      image: '/Picture9.png'
    },
    {
      name: 'Aditya B Vishwanath',
      position: 'R&D Head',
      image: '/Picture1.png'
    },
    {
      name: 'Dr. Suryansh Gupta',
      position: 'Medical Expert',
      image: '/Picture10.png'
    },
    {
      name: 'Dr. Mueen Ahmed',
      position: 'Business Advisor',
      image: '/1574183073159.jpg'
    }
  ];
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2>About Heal AI</h2>
            <h3>Our Mission</h3>
            <p>
              At Heal AI, we're on a mission to revolutionize healthcare by making AI-powered
              diagnostics accessible to everyone. We believe technology should empower both patients
              and healthcare providers with better, faster, and more accurate tools.
            </p>
            
            <h3>Our Story</h3>
            <p>
              Founded by a team of healthcare professionals and AI experts, Heal AI was born from
              the need to address critical gaps in wound care management for diabetic patients.
              What started as a research project has evolved into a comprehensive healthcare solution.
            </p>
          </div>
          <div className="team-section">
            <h3>Our Team</h3>
            <div className="team-grid">
              {teamMembers.map((member, index) => (
                <div key={index} className="team-member">
                  <div className="member-avatar">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <h4>{member.name}</h4>
                  <p>{member.position}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
